import { render, staticRenderFns } from "./DsSalesRankDetails.vue?vue&type=template&id=0c9a95cc&scoped=true"
import script from "./DsSalesRankDetails.vue?vue&type=script&lang=js"
export * from "./DsSalesRankDetails.vue?vue&type=script&lang=js"
import style0 from "./DsSalesRankDetails.vue?vue&type=style&index=0&id=0c9a95cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9a95cc",
  null
  
)

export default component.exports